// Copyright (c) 2022. Heusala Group Oy <info@heusalagroup.fi>. All rights reserved.

import { MY_ORDER_NO_CART_ARTICLE_CLASS_NAME } from "../../../../../core/constants/className";
import {
    T_MY_ORDER_VIEW_NO_CART_TEXT,
    T_MY_ORDER_VIEW_NO_CART_TITLE
} from "../../../../../core/constants/translation";

import "./MyOrderNoCartArticle.scss";
import { TranslationFunction } from "../../../../../../../io/hyperify/core/types/TranslationFunction";

export interface MyOrderNoCartArticleProps {
    readonly className ?: string;
    readonly t          : TranslationFunction;
}

export function MyOrderNoCartArticle (props: MyOrderNoCartArticleProps) {

    const className = props?.className;
    const t = props?.t;

    return (
        <article className={
            MY_ORDER_NO_CART_ARTICLE_CLASS_NAME
            + (className? ` ${className}` : '')
        }>
            <h3>{t(T_MY_ORDER_VIEW_NO_CART_TITLE)}</h3>
            <p>{t(T_MY_ORDER_VIEW_NO_CART_TEXT)}</p>
        </article>
    );

}
